window.ActivityBasedSchedulingAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration['ABSServers']);

    /**
     * get brand forecasting settings
     * @param brandId
     */
    self.getBrandForecastingSettings = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/forecasts/settings', 'GET')
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * update brand forecasting settings
     * @param brandId
     * @param forecastingSettings
     */
    self.updateBrandForecastingSettings = function (brandId, forecastingSettings) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";

        }

        _protected.request('brands/' + brandId + '/forecasts/settings', 'PATCH', forecastingSettings)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * get brand adjustments settings
     * @param brandId
     * @param settingsType
     */
    self.getBrandAdjustments = function (brandId, settingsType) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/labor_forecasts/adjustments', 'GET', settingsType)
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * create a new adjustment
     * @param brandId
     * @param adjustment
     */
    self.createNewAdjustment = function (brandId, adjustment) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/labor_forecasts/adjustments', 'POST', adjustment)
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * update adjustment
     * @param brandId
     * @param adjustment
     */
    self.updateAdjustment = function (brandId, adjustment) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!adjustment.id) {
            throw "No adjustment id";
        }

        _protected.request('brands/' + brandId + '/labor_forecasts/adjustments/' + adjustment.id, 'PUT', adjustment)
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * delete adjustment
     * @param brandId
     * @param adjustment
     */
    self.deleteAdjustment = function (brandId, adjustmentId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!adjustmentId) {
            throw "No adjustment id";
        }

        _protected.request('brands/' + brandId + '/labor_forecasts/adjustments/' + adjustmentId, 'DELETE')
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };


    self.generateLaborForecastProjections = function (brandId, startDate, adjustments, positions_templates, guided_templates) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        var payload = {
            "start_date": startDate,
            "adjustment_ids": adjustments || []
        };

        if (positions_templates && positions_templates.length) {
            payload.positions_templates = positions_templates;
        }

        if (guided_templates && guided_templates.length) {
            payload.guided_templates = guided_templates;
        }

        _protected.request('brands/' + brandId + '/labor_forecasts/generate', 'POST', payload)
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * get brand labor forecasts
     * @param brandId
     * @param startWeekDate
     * @param endWeekDate
     * @param mode
     */
    self.getBrandLaborForecasts = function (brandId, mode, startWeekDate, endWeekDate) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!startWeekDate) {
            throw "start week date are required";
        }

        var params = {
            mode: mode
        };

        if (mode === 'BASIC') {
            params['end_week_date'] = endWeekDate;
            params['start_week_date'] = startWeekDate;
        }
        else {
            params['start_date'] = startWeekDate;
        }

        _protected.request('brands/' + brandId + '/labor_forecasts', 'GET', params)
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteForecast = function (brandId, forecastId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!forecastId) {
            throw "No forecast id";
        }

        _protected.request('brands/' + brandId + '/labor_forecasts/' + forecastId, 'DELETE')
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.generateSchedule = function (brandId, startDate) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        var payload = {
            start_date: startDate
        };

        _protected.request('brands/' + brandId + '/labor_forecasts/publish', 'POST', payload)
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getABSBrandSettings = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/settings', 'GET')
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createGroup = function (brandId, group) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/groups', 'POST', group)
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateGroup = function (brandId, groupId, group) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!groupId) {
            throw "No group id";
        }

        _protected.request('brands/' + brandId + '/groups/' + groupId, 'PUT', group)
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandGroups = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/groups', 'GET')
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getGroupDetails = function (brandId, groupId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!groupId) {
            throw "No group id";
        }

        _protected.request('brands/' + brandId + '/groups/' + groupId, 'GET')
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteGroup = function (brandId, groupId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!groupId) {
            throw "No group id";
        }

        _protected.request('brands/' + brandId + '/groups/' + groupId, 'DELETE')
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteGuidedGroup = function (brandId, groupId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!groupId) {
            throw "No group id";
        }

        _protected.request('brands/' + brandId + '/guided_hours/groups/' + groupId, 'DELETE')
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createTemplate = function (brandId, template) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/templates', 'POST', template)
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandTemplates = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/templates', 'GET')
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateTemplate = function (brandId, templateId, template) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!templateId) {
            throw "No template id";
        }

        _protected.request('brands/' + brandId + '/templates/' + templateId, 'PUT', template)
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getTemplateDetails = function (brandId, templateId) {
        var deferred = $q.defer();


        if (!brandId) {
            throw "No brand id";
        }

        if (!templateId) {
            throw "No template id";
        }

        _protected.request('brands/' + brandId + '/templates/' + templateId, 'GET')
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteTemplate = function (brandId, templateId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!templateId) {
            throw "No template id";
        }

        _protected.request('brands/' + brandId + '/templates/' + templateId, 'DELETE')
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    }

    self.updateForecastIntervals = (brandId, laborId, payload) => {
        const deferred = $q.defer();

        _protected.request( `/brands/${brandId}/labor_forecasts/${laborId}`, 'PUT', payload)
            .then((res) => {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else  {
                    deferred.reject(res);
                }
            }).catch((err) => {
                deferred.reject(err);
            })

        return deferred.promise;
    };

    self.generateWeekForecast = function (brandId, starWeekDate , payload) {
        var deferred = $q.defer();
        var url = 'brands/' + brandId + '/forecast/generate?start_week_date='+starWeekDate;
        _protected.request(url, 'POST', payload)
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    }

    self.adjustForecast = function (brandId, startWeekDate, data) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!startWeekDate) {
            throw "No start week date";
        }

        var url = 'brands/' + brandId + '/forecast?start_week_date=' + startWeekDate;
        _protected.request(url, 'PUT', data)
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getPrimaryTemplate = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/forecasts/settings/primary_templates', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    //call outside settings
    self.getPrimaryTemplatesList = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/forecasts/primary_templates', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };
    
    self.setAsPrimaryTemplateForPosition = function (brandId, primaryTemplate) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/forecasts/settings/primary_templates', 'PUT', primaryTemplate)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    }

    self.unmarkPrimaryTemplateForPosition = function (brandId, primaryTemplateId , primaryTemplate) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/forecasts/settings/primary_templates/' + primaryTemplateId, 'DELETE', primaryTemplate)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    }

    self.getGuidedPrimaryTemplates = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/forecasts/settings/guided_hours/primary_templates', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            })
            .catch(function (err) {
                deferred.reject(err);
            });


        return deferred.promise;
    };

    self.setAsGuidedPrimaryTemplateForEmploymentTitle = function (brandId, primaryTemplate) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/forecasts/settings/guided_hours/primary_templates', 'PUT', primaryTemplate)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.unmarkGuidedPrimaryTemplateForEmploymentTitle = function (brandId, primaryTemplateId , primaryTemplate) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/forecasts/settings/guided_hours/primary_templates/' + primaryTemplateId, 'DELETE', primaryTemplate)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    }

    self.getBrandFixedHours = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/forecasts/settings/fixed_hours', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data.fixed_hours);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createBrandFixedHour = function (brandId, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/forecasts/settings/fixed_hours', 'POST', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 201) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateBrandFixedHour = function (brandId, fixedHourId, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/forecasts/settings/fixed_hours/' + fixedHourId, 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 201) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteBrandFixedHour = function (brandId, fixedHourId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/forecasts/settings/fixed_hours/' + fixedHourId, 'DELETE')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 201) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandGuidedFixedHours = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/forecasts/settings/guided_hours/fixed_hours', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateBrandGuidedFixedHour = function (brandId, guidedFixedHourId, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/forecasts/settings/guided_hours/fixed_hours/' + guidedFixedHourId, 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 201) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createBrandGuidedFixedHour = function (brandId, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/forecasts/settings/guided_hours/fixed_hours', 'POST', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteBrandGuidedFixedHour = function (brandId, fixedHourId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/forecasts/settings/guided_hours/fixed_hours/' + fixedHourId, 'DELETE')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 201) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createGuidedTemplate = function (brandId, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/guided_hours/templates', 'POST', payload)
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateGuidedTemplate = function (brandId, templateId, payload) {
        var deferred = $q.defer();

        if (!brandId || !templateId) {
            throw "must provide brand id and template id";
        }

        _protected.request('brands/' + brandId + '/guided_hours/templates/' + templateId, 'PUT', payload)
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getGuidedTemplateDetails = function (brandId, templateId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!templateId) {
            throw "No template id";
        }

        _protected.request('brands/' + brandId + '/guided_hours/templates/' + templateId, 'GET')
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandGuidedTemplates = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/guided_hours/templates', 'GET')
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandGuidedGroups = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/guided_hours/groups', 'GET')
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createGuidedGroup = function (brandId, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/guided_hours/groups', 'POST', payload)
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateGuidedGroup = function (brandId, groupId, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!groupId) {
            throw "No group id";
        }

        _protected.request('brands/' + brandId + '/guided_hours/groups/' + groupId, 'PUT', payload)
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getLaborForecastGuideHours = function (brandId, startDate) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!startDate) {
            throw "No start date";
        }

        var params = {start_date: moment(startDate).format('YYYY-MM-DD')};

        _protected.request('brands/' + brandId + '/labor_forecasts/guided_hours', 'GET', params)
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getScheduledGenericTemplates = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/scheduled/generic_templates', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data.templates);
                } else {
                    deferred.reject(res);
                }
            }).catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createScheduledGenericTemplates = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/scheduled/generic_templates', 'POST', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data.template);
                } else {
                    deferred.reject(res);
                }
            }).catch(function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.updateScheduledGenericTemplate = function (brandId, payload, templateId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/scheduled/generic_templates/' + templateId, 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data.template);
                } else {
                    deferred.reject(res);
                }
            }).catch(function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getAppliedScheduledGenericTemplates = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/scheduled/applied_generic_templates', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data.templates);
                } else {
                    deferred.reject(res);
                }
            }).catch(function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getGuidedHoursGenericTemplates = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/guided/generic_templates', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data.templates);
                } else {
                    deferred.reject(res);
                }
            }).catch(function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.createGuidedHoursGenericTemplates = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/guided/generic_templates', 'POST', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data.template);
                } else {
                    deferred.reject(res);
                }
            }).catch(function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.updateGuidedHoursGenericTemplate = function (brandId, payload, templateId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/guided/generic_templates/' + templateId, 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data.template);
                } else {
                    deferred.reject(res);
                }
            }).catch(function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getTargetHoursForecastIntervals = async (brandId, startWeekDate) => {
        let params = {
            start_week_date: startWeekDate
        }

        const response = await _protected.request( `brands/${brandId}/TARGET_HOURS/labor_forecasts`, 'GET', params);
        if (response?.status === 200 && response.data?.data) {
            return response.data.data.labor_forecast;
        }
        throw response;
    };


    self.getAppliedGuidedGenericTemplates = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/guided/applied_generic_templates', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data.templates);
                } else {
                    deferred.reject(res);
                }
            }).catch(function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getForecastSourceWeeks = function (brandId, params) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/forecast/source_weeks', 'GET', params)
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    }

    self.addNewForecastingRule = async (brandId, payload) => {
        let res = await _protected.request(`brands/${brandId}/rules`, 'POST', payload);
        if (res?.data?.data && (res.status === 200 || res.status === 201)) {
            return res.data.data;
        }
        throw res;
    };

    self.duplicateForecastingRule = async (brandId, ruleId, payload) => {
        let res = await _protected.request(`brands/${brandId}/rules/${ruleId}/copy`, 'POST', payload);
        if (res?.data?.data && (res.status === 200 || res.status === 201)) {
            return res.data.data;
        }
        throw res;
    };

    self.getRuleDetails = async (brandId, ruleId, version) => {
        let params = {
            version_uuid: version
        };
        let res = await _protected.request(`brands/${brandId}/rules/${ruleId}`, 'GET', params);
        if (res?.data?.data && res.status === 200) {
            return res.data.data;
        }
        throw res;
    };

    self.updateRuleDetails = async (brandId, ruleId, version, payload) => {
        let res = await _protected.request(`brands/${brandId}/rules/${ruleId}${version ? `?version_uuid=${version}` : ''}`, 'PUT', payload);
        if (res?.data?.data && res.status === 200) {
            return res.data.data;
        }
        throw res;
    };

    self.getTemplateScheduleHours = async (brandId, ruleId, version) => {
        let params = {
            version_uuid: version
        };
        let res = await _protected.request(`brands/${brandId}/rules/${ruleId}/scheduled_templates`, 'GET', params);
        if (res?.data?.data && res.status === 200) {
            return res.data.data;
        }
        throw res;
    };

    self.updateTemplateScheduleHours = async (brandId, ruleId, version, payload) => {
        let res = await _protected.request(`brands/${brandId}/rules/${ruleId}/scheduled_templates${version ? `?version_uuid=${version}` : ''}`, 'PUT', payload);
        if (res?.data?.data && res.status === 200) {
            return res.data.data;
        }
        throw res;
    };

    self.getScheduleFixedHours = async (brandId, ruleId, version) => {
        let params = {
            version_uuid: version
        };
        let res = await _protected.request(`brands/${brandId}/rules/${ruleId}/scheduled_fixed_hours`, 'GET', params);
        if (res?.data?.data && res.status === 200) {
            return res.data.data?.scheduled_fixed_hours;
        }
        throw res;
    };

    self.updateScheduleFixedHours = async (brandId, ruleId, version, payload) => {
        let res = await _protected.request(`brands/${brandId}/rules/${ruleId}/scheduled_fixed_hours${version ? `?version_uuid=${version}` : ''}`, 'PUT', payload);
        if (res?.data?.data && res.status === 200) {
            return res.data.data;
        }
        throw res;
    };

    self.deleteForecastRule = async (brandId, ruleId) => {
        let res = await _protected.request(`brands/${brandId}/rules/${ruleId}`, 'DELETE');
        if (res?.data?.data && res.status === 200) {
            return res.data.data;
        }
        throw res;
    }

    self.getForecastRules = async (brandId) => {
        let res = await _protected.request(`brands/${brandId}/rules`, 'GET');
        if (res?.data?.data && res.status === 200) {
            return res.data.data;
        }
        throw res;
    };

    self.getTemplateGuidedHours = async (brandId, ruleId, version) => {
        let params = {
            version_uuid: version
        };
        let res = await _protected.request(`brands/${brandId}/rules/${ruleId}/guided_templates`, 'GET', params);
        if (res?.data?.data && res.status === 200) {
            return res.data.data;
        }
        throw res;
    };

    self.updateTemplateGuidedHours = async (brandId, ruleId, version, payload) => {
        let res = await _protected.request(`brands/${brandId}/rules/${ruleId}/guided_templates${version ? `?version_uuid=${version}` : ''}`, 'PUT', payload);
        if (res?.data?.data && res.status === 200) {
            return res.data.data;
        }
        throw res;
    };

    self.getGuidedFixedHours = async (brandId, ruleId, version) => {
        let params = {
            version_uuid: version
        };
        let res = await _protected.request(`brands/${brandId}/rules/${ruleId}/guided_fixed_hours`, 'GET', params);
        if (res?.data?.data && res.status === 200) {
            return res.data.data?.fixed_hours;
        }
        throw res;
    };

    self.updateGuidedFixedHours = async (brandId, ruleId, version, payload) => {
        let res = await _protected.request(`brands/${brandId}/rules/${ruleId}/guided_fixed_hours${version ? `?version_uuid=${version}` : ''}`, 'PUT', payload);
        if (res?.data?.data && res.status === 200) {
            return res.data.data;
        }
        throw res;
    };

    self.getForecastTypes = async (brandId) => {
        let res = await _protected.request(`brands/${brandId}/forecast_types`, 'GET');
        if (res?.data?.data && res.status === 200) {
            return res.data.data.forecast_types;
        }
        throw res;
    };

    self.getAbsBusinessSettings = async (brandId) => {
        let res = await _protected.request(`brands/${brandId}/business/settings`, 'GET');
        if (res?.data?.data && res.status === 200) {
            return res.data.data.settings;
        }
        throw res;
    };

    self.getIsCategoriesEnabled = async (brandId) => {
        let res = await _protected.request(`brands/${brandId}/categories`, 'GET');
        if (res?.data?.data && res.status === 200) {
            return res.data.data.enabled;
        }
        throw res;
    };

    self.getBulkSelectedBrands = async (brandId, ruleId) => {
        let res = await _protected.request(`brands/${brandId}/rules/${ruleId}/brands`, 'GET');
        if (res?.data?.data && res.status === 200) {
            return res.data.data.brands;
        }
        throw res;
    };

    self.applyBulkRule = async (brandId, ruleId, version, inPlaceUpdate, override, payload) => {
        const urlParams = new URLSearchParams();
        if (version) {
            urlParams.set('version_uuid', version);
        }

        if (inPlaceUpdate) {
            urlParams.set('in_place_update', inPlaceUpdate);
        }

        if (override) {
            urlParams.set('override_existing_brands_rules', override);
        }

        let res = await _protected.request(`brands/${brandId}/rules/${ruleId}/brands${urlParams.size ? `?${urlParams.toString()}` : ''}`, 'POST', payload);
        if (res?.data?.data && (res.status === 200 || res.status === 201)) {
            return res.data.data.brands;
        }
        throw res;
    };

    self.getSettingsRule = async (brandId) => {
        let res = await _protected.request(`brands/${brandId}/settings/rules`, 'GET');
        if (res.status === 200) {
            return res.data.data;
        }
        throw res;
    }

});